module.exports = __webpack_public_path__ + "img/专利导航.4a83e131.png";